import { ReactComponent as SvgSnowflake } from 'public/assets/icons/snowflakeFlat.svg';
import { ResortPhotosData } from '@/components/widget/types';
import { ImageComponent } from '@/components/common/ImageComponent';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { SectionHeader } from '../SectionHeader';

const wrapperClass = 'relative mt-2 mb-3';
const imageBoxClass = 'z-[1] w-3/4 sticky lg:w-2/3 [&>img]:rounded-[20px]';
const snowflakeBoxClass = [
  '[&>svg]:w-[27%] [&>svg]:h-auto [&>svg]:absolute [&>svg]:top-[15%]',
  '[&>svg]:right-[15px] [&>svg]:z-0',
  'lg:[&>svg]:w-[36%] lg:[&>svg]:top-[9%]',
].join(' ');

interface Props {
  paragraphs?:
  | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  }
  | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  };
  photos?: ResortPhotosData;
}

export const InsideScoopSection = ({ paragraphs, photos }: Props) => {
  const { t } = useOTSTranslation('common');
  return (
    <section>
      <SectionHeader title={t('resort.overview.insideScoopTab')} />

      {photos && photos[0] && (
        <div className={wrapperClass}>
          <div className={imageBoxClass}>
            <ImageComponent alt={photos[0].name} src={photos[0].cdnUrl} />
          </div>

          <div className={snowflakeBoxClass}>
            <SvgSnowflake width="100%" height="100%" viewBox="0 0 176 193" />
          </div>
        </div>
      )}

      <SectionHeader description={paragraphs} />
    </section>
  );
};
